/**
 * Adds provided scopeValue as another scopeKey of the MapperScopeContext
 */
export var Mapper = function Mapper(_ref) {
  var children = _ref.children;
  return children;
};